import React from "react";
import "./loadershade.css";

function LoaderShade({ classname = "" }) {
   return <div className={` ${classname} loading-dynamic-new `}></div>;
}

export default LoaderShade;
